<template>
  <v-dialog
    v-model="getModalCartaCorrecaoNfe"
    persistent
    :overlay="false"
    max-width="720px"
    fullscreen
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>
        <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
          <v-tab>
            <span>GERAR CC-e</span>
          </v-tab>

          <v-tab>
            <span>GERADOS</span>
          </v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tabs" class="pa-8">
          <v-tab-item>
            <v-form class="px-3" ref="formGerarCCe">
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <v-alert
                    color="warning"
                    dark
                    icon="warning"
                    border="left"
                    prominent
                    class="ml-2 mr-2"
                  >
                    A Carta de Correcao é disciplinada pelo paragrafo 1º-A do
                    art. 7º do Convenio S/N, de 15 de dezembro de 1970 e pode
                    ser utilizada para regularizacao de erro ocorrido na emissao
                    de documento fiscal, desde que o erro nao esteja relacionado
                    com:
                    <ul>
                      <li>
                        I - as variaveis que determinam o valor do imposto tais
                        como: base de calculo, aliquota, diferenca de preco,
                        quantidade, valor da operacao ou da prestacao;
                      </li>
                      <li>
                        II - a correcao de dados cadastrais que implique mudanca
                        do remetente ou do destinatario;
                      </li>
                      <li>III - a data de emissao ou de saida.</li>
                    </ul>
                  </v-alert>
                  <!-- <v-textarea
                dense
                label="Condições de uso para carta de correção"
                outlined
                class="ml-2 mr-2"
                readonly
                value=""
              >
              </v-textarea> -->
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    dense
                    label="Correção"
                    outlined
                    class="ml-2 mr-2"
                    v-model="correcao"
                    :rules="rules.correcao"
                  >
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>CÓD</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in getVenda.cartas_correcao" :key="i.id">
                    <td>{{ i.id }}</td>
                    <td>
                      <v-btn
                        color="primary"
                        outlined
                        @click="
                          imprimirCartaCorrecao({
                            venda_id: getVenda.id,
                            carta_correcao_id: i.id,
                          })
                        "
                        x-small
                        >Visualizar</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" @click="setModalCartaCorrecaoNfe(false)" outlined
          >Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" @click="modalConfirmacao = true" outlined
          >Gerar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="modalConfirmacao"
      persistent
      max-width="720px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title> Gerar CC-e </v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja gerar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="modalConfirmacao = false" outlined
            >Voltar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" @click="gerar()" outlined>Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    correcao: "",
    modalConfirmacao: false,
    rules: {
      correcao: [(v) => !!v || "Campo obrigatório."],
    },
    tabs: 0,
  }),
  computed: {
    ...mapGetters(["getModalCartaCorrecaoNfe", "getVenda"]),
  },
  watch: {
    getModalCartaCorrecaoNfe() {
      if (this.getModalCartaCorrecaoNfe == false) {
        this.correcao = "";
      }
    },
  },
  methods: {
    ...mapActions([
      "setModalCartaCorrecaoNfe",
      "gerarCartaCorrecaoNfe",
      "imprimirCartaCorrecao",
    ]),
    gerar() {
      this.modalConfirmacao = false;
      if (this.$refs.formGerarCCe.validate() == false) {
        return;
      }
      this.gerarCartaCorrecaoNfe({
        venda_id: this.getVenda.id,
        correcao: this.correcao,
      });
    },
  },
};
</script>